<!-- <div class="example-action-buttons">
  <button mat-button (click)="accordion.openAll()">Expand All</button>
  <button mat-button (click)="accordion.closeAll()">Collapse All</button>
</div> --><!-- <span class="example-list-section">
        <mat-checkbox class="example-margin"
                      [checked]="allComplete"
                      [indeterminate]="someComplete(i)"
                      (change)="setAll($event.checked,i)">
          {{unidad.unidad}}
        </mat-checkbox>
      </span> -->
<div class="display-flex">
  <mat-icon>filter_list</mat-icon>
  <p class="title">Filtros</p>
</div>
<div>
  <p class="title2">Unidades</p>
</div>
<mat-accordion class="example-headers-align" multi>
  <mat-expansion-panel *ngFor="let unidad of data; let i = index">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ unidad.name }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <section class="example-section">
      <span class="example-list-section">
        <ul>
          <li *ngFor="let tipo_caso of unidad.ct; let j = index">
            <mat-checkbox
              [(ngModel)]="tipo_caso.checked"
              color="primary"
              (ngModelChange)="updateAllComplete(i, j)"
              (click)="selectOption(tipo_caso.name)"
            >
              {{ tipo_caso.name }}
            </mat-checkbox>
          </li>
        </ul>
      </span>
    </section>
  </mat-expansion-panel>
</mat-accordion>

<!-- <div class="title">
  <h3>Notificaciones</h3>
</div>
<div
  class="item"
  [ngClass]="{ active: activeTab == 'all' }"
  (click)="setTab('all')"
>
  <p><mat-icon>ballot</mat-icon> Todas</p>
</div>
<div class="units">
  <p>Unidades</p>
</div>
<div>
  <div
    class="item"
    *ngFor="let unidad of tiposCasoXUnidades"

  >
    <p class="unit">
      <mat-icon>local_offer</mat-icon> {{ unidad.unidad }}
    </p>
    <div
      class="subitems"
      (click)="$event.stopPropagation()"
    >
      <div
        class="subitem"
        *ngFor="let tipo_caso of unidad.tipo_caso"
      >
        <mat-checkbox [value]="true">
          {{ tipo_caso.name }}
        </mat-checkbox>
      </div>
    </div>
  </div>
</div> -->
